import {useContext} from 'react';
import WebSocketContext, {
    WebSocketContextInterface,
} from '@/context/WebSocketContext';

export function useSocket() {
  return useContext<WebSocketContextInterface>(WebSocketContext);
}